// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StockOutlinedSvg from "@fishx/icons-svg/es/asn/StockOutlined";
import FishxIcon from '../components/FishxIcon';

var StockOutlined = function StockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StockOutlinedSvg
  }));
};

StockOutlined.displayName = 'StockOutlined';
export default React.forwardRef(StockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StockOutlined.js
// module id = 4193
// module chunks = 0